import { render, staticRenderFns } from "./ImportarCriterio.vue?vue&type=template&id=e3702642&scoped=true"
import script from "./ImportarCriterio.vue?vue&type=script&lang=js"
export * from "./ImportarCriterio.vue?vue&type=script&lang=js"
import style0 from "./ImportarCriterio.vue?vue&type=style&index=0&id=e3702642&prod&scoped=true&lang=css"
import style1 from "./ImportarCriterio.vue?vue&type=style&index=1&id=e3702642&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3702642",
  null
  
)

export default component.exports